// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-wizard .finish-btn[data-v-c907f850] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
